jQuery(document).ready(function($) {
  $(".slider--v2-multiple__category").on("click", function(e) {
    const { currentTarget } = e;
    const categoryActiveClass = "slider--v2-multiple__category--active";
    const sliderActiveClass = "slider--v2-multiple__swiper--active";

    if ($(currentTarget).hasClass(categoryActiveClass)) return;

    const index = $(currentTarget).data("slider-index");
    const nextBtn = document.querySelector(
      `.swiper-btn-container[data-slider="${index}"]`
    );

    // Remove previous active
    $(`.${categoryActiveClass}`).removeClass(categoryActiveClass);

    $(currentTarget).addClass(categoryActiveClass);

    const active = $(`.${sliderActiveClass}`);
    active.removeClass(sliderActiveClass);

    $(`.slider--v2-multiple__swiper `).removeClass(sliderActiveClass);
    $(`.slider--v2-multiple__swiper[data-slider-index="${index}"]`).addClass(
      sliderActiveClass
    );

    $(".swiper-btn-container--active").removeClass(
      "swiper-btn-container--active"
    );

    $(nextBtn).addClass("swiper-btn-container--active");
  });
});
